import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Container, Fab, Tooltip, Backdrop } from "@material-ui/core";
import { Link, useHistory, Route } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";

import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from "../../components/Common/styles";
import SiteStatusManage from "./site.status.manage";
import SiteStatusCreate from "./site.status.create";
import { useFetchSiteStatuses } from "../../hooks/useFetchEntities";

function SiteStatuses() {
  const history = useHistory();
  const classes = useStyles();
  const [siteStatuses, fetched] = useFetchSiteStatuses();

  const [loading, setLoading] = useState(false);

  const onRowClick = (rowData, rowMeta) => {
    history.push("/sitestatuses/manage/" + rowData[0]);
  };

  useEffect(() => {
    setLoading(!fetched);
  }, [fetched]);

  const gridOptions = {
    fixedHeader: true,
    tableBodyMaxHeight: "60vh",
    filterType: "multiselect",
    selectableRows: "none",
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    onRowClick: onRowClick,
    print: false,
    download: false,
  };

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        display: true,
      },
    },
  ];

  const fabStyle = {
    right: 20,
    position: "fixed",
  };

  return (
    <div style={{ marginRight: 32 }}>
      <Tooltip title="Add" aria-label="add">
        <Fab color="primary" aria-label="add" style={fabStyle} component={Link} to={"/sitestatuses/create"}>
          <AddIcon />
        </Fab>
      </Tooltip>
      {!loading && (
        <MUIDataTable title={"Site Statuses"} data={siteStatuses} columns={gridColumns} options={gridOptions} />
      )}
      <Route exact path="/sitestatuses/manage/:siteStatusId">
        <SiteStatusManage />
      </Route>
      <Route path="/sitestatuses/create">
        <SiteStatusCreate />
      </Route>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="secondary" />
      </Backdrop>
    </div>
  );
}

export default SiteStatuses;
